'use strict';

export default {
    NODE_ENV: "production",
    BUILD_ENV: "production", //staging
    BASE_URL: "https://procheck-cms.nbtc.go.th",
    API_URL: "https://procheck-cms.nbtc.go.th/webservice/",
    // BASE_URL: "http://172.17.200.177",
    // API_URL: "http://172.17.200.177/webservice/",
    //API_URL: "http://172.17.200.77:8081/",
    // SERVER_MINER: "https://procheck-cms.nbtc.go.th:57085",
    LIMIT: 10
};
